module.exports = __webpack_public_path__ + "img/financial-planIcon.dffb525a.svg";